import React, { Component } from 'react';
import { MemoryRouter,Switch,Route,Redirect,withRouter} from "react-router-dom";
import {TabBar} from 'app/components/Basics';
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import {QuotaFormContext} from './QuotaContext'
import QuotaService from "app/services/quota.service";
import  GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import NewQuotaDef from './models/QuotaDefModel';
import Modal from 'app/components/Modal';
import cloneDeep from 'lodash/cloneDeep';
import TabParameters from './components/TabParameters/TabParametersComponent';
import isEqual from 'lodash/isEqual';
import ValidateQuota from './QuotaValidation'

class QuotaForm extends Component {
    tabs = [];	
    constructor(props){
        super(props);
        this.state = {           
            activeTab:'parameters',
            selectedQuota: NewQuotaDef(),
            errors: []		
        }
    }

    getTabs(){        
        return [            
            { id:"parameters", label: 'Parameters', url: 'parameters', disabled:false, error:false},
        ];
    }

	componentWillReceiveProps(nextProps) {
		if (nextProps.selectedQuota != null) {
			this.setState({ 
				selectedQuota: nextProps.selectedQuota,
				activeTab: "parameters"
			});
		}	

        if (!isEqual(this.props.selectedQuota, nextProps.selectedQuota)) {
            this.setState({errors: []});            
        }
    }	

    updateSelectedQuota(newSelectedQuota) {
		this.setState({selectedQuota: newSelectedQuota})
    }

    addErrorMessage(field, message) {
        var errors = this.state.errors;
        errors.push({ field: field, errorMessage: message});
        this.setState({errors: errors})
    }	

    SaveQuota(quota) {
        console.log("SaveQuota")
        console.log(quota)
        this.props.toggleUiBlock(true);
        if (quota.id) {
            QuotaService.updateQuota(quota)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The quota was saved successfully' });                    
					this.props.getQuotaById(quota.id);
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }
        else {
            QuotaService.createQuota(quota)
                .then(response => {					
                    const newQuota = response.data;                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The quota was created successfully' });                                        
                    this.setState({selectedQuota: newQuota});					
					this.props.getQuotaById(newQuota.id);
					
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }

    }
    deleteQuota = event => {        
        this.setState({ deleteQuotaModalText: `Are you sure you want to delete the quota with name '${this.state.selectedQuota.name}'?`});
    }

    duplicateQuota = event => {        
        let cloned = cloneDeep(this.state.selectedQuota);
        cloned.id = null;
        cloned.name = `${cloned.name}_copy`;
		this.props.updateSelectedQuota(cloned);
    }

    confirmDelete() {        
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);
        const quotaId = this.state.selectedQuota.id;
        QuotaService.deleteQuota(this.state.selectedQuota)
        .then(response =>{            
            this.setState({successMessage: 'The quota was deleted successfully' });            
            this.props.removeDeletedQuota(quotaId);
			setTimeout(() => {
				this.props.toggleUiBlock(false);
				this.props.closeEditor();				
			}, 2000);

            
        })
        .catch(error => {
            let errorMessage = GetErrorMessage(error);
            console.log("errorMessage on catch");
            console.log(errorMessage);
            this.props.toggleUiBlock(false);
            this.setState({ errorMessage: errorMessage});
        });
    }

    hideDeleteModal() {
        this.setState({deleteQuotaModalText: ''})
    }    

    handleSubmitAction = event => { 
		var validationErrors = ValidateQuota(this.state.selectedQuota);
		this.setState({errors: validationErrors});
		if (validationErrors && validationErrors.length === 0) {                    
			this.SaveQuota(this.state.selectedQuota);
		}        
        return;
    }

    render() {

        this.tabs = this.getTabs(this.state.selectedQuota);
        return (        
               
            <div className="AppFormComponent QuotaForm">                 
                <QuotaFormContext.Provider value={{updateSelectedQuota: this.updateSelectedQuota.bind(this), selectedQuota: this.state.selectedQuota}}>                
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                        <GlobalControlLine errors={this.state.errors} 
                            handleSubmitAction={this.handleSubmitAction.bind(this)} 
                            deleteQuota={this.deleteQuota.bind(this)}
                            duplicateQuota={this.duplicateQuota.bind(this)}
                            closeEditorButtonOnClick={this.props.closeEditorButtonOnClick}
							didSelectedQuotaChange={this.props.didSelectedQuotaChange}								
							canChangeData={this.props.canChangeData}
							/>
                        <div className="form-sections">
                            <MemoryRouter>
                                <div className="tab-bar">
                                    <TabBar key="QuotaForm" activeTab={this.state.activeTab} tabs={this.tabs} onTabActivate={item=>this.setState({activeTab:item.id})}/>
                                    {/* <div title="Load the current tab settings from another quota." className="duplicate-tab"><ButtonIcon icon={DuplicateIcon}/></div> */}
                                </div>
                                <div className="section-content">
                                    <Switch>
                                        <Route exact path="/"><Redirect to={this.state.activeTab}/></Route>                                        
                                        <Route exact path="/parameters"><TabParameters canChangeData={this.props.canChangeData} metadata={this.props.metadata} errors={this.state.errors} /></Route>
                                    </Switch>
                                    <Redirect to={this.state.activeTab}/>
                                </div>
                            </MemoryRouter>
                        </div>
                    </form>                    
                </QuotaFormContext.Provider>

                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}
                {this.state.deleteQuotaModalText && ( <Modal content={this.state.deleteQuotaModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}				
            </div>            
        );
    }
}
export default withRouter(QuotaForm); 